/**
 * All known adunits
 *
 * dyn in the id will allow multiple registrations
 */ import { TEST_REALESTATEID } from './adunits/dealer/DealerAdIframe';
// prettier-ignore
export const ADUNIT_MAP = {
    // Anon
    DesktopDevPageSide300x250Gam: 'desktop-devpage-sidebar-300x250-btf',
    DesktopDevPageSide300x250AtfGam: 'desktop-devpage-sidebar-300x250-atf',
    DesktopDevPageSideVideoSideGam: 'desktop-devpage-video-sidebar-atf',
    DesktopDevPageStage728x90Gam: 'desktop-devpage-artstage-728x90-atf',
    DesktopDevPageArtStageVideo: 'desktop-devpage-artstage-video-atf',
    DesktopComments728x90Gam: 'desktop-devpage-comment-728x90-btf',
    DesktopProfileBottom728x90Gam: 'desktop-profile-gallery-foot-728x90-btf',
    DesktopProfileTop728x90Gam: 'desktop-profile-gallery-top-728x90-btf',
    DesktopProfileVideoGam: 'desktop-profile-video',
    DesktopBrowseTop728x90Gam: 'desktop-browse-top-728x90-atf',
    DesktopBrowseBottom728x90Gam: 'desktop-browse-bottom-728x90-btf',
    DesktopBrowseRight160x600Gam: 'desktop-browse-right-160x600-atf',
    DesktopAdhesionGam: 'desktop-anchor',
    MobileAdhesionGam: 'mobile-anchor',
    AdhesionGam: 'responsive-anchor',
    MobileDevPageVideoStageGam: 'mobile-devpage-video-artstage-atf',
    MobileDevPageSide300x250Gam: 'mobile-devpage-sidebar-300x250-btf',
    MobileDevPageStage320x100Gam: 'mobile-devpage-artstage-320x100-atf',
    MobileGridDynamic300x250Gam: 'mobile-grid-dyn-300x250-btf',
    // User
    UserDesktopDevPageSide300x250Gam: 'u-desktop-devpage-sidebar-300x250-btf',
    UserDesktopDevPageSide300x250AtfGam: 'u-desktop-devpage-sidebar-300x250-atf',
    UserDesktopDevPageStage728x90Gam: 'u-desktop-devpage-artstage-728x90-atf',
    UserDesktopComments728x90Gam: 'u-desktop-devpage-comment-728x90-btf',
    UserDesktopAdhesionGam: 'u-desktop-anchor',
    UserDesktopProfileBottom728x90Gam: 'u-desktop-profile-gallery-foot-728x90-btf',
    UserDesktopProfileTop728x90Gam: 'u-desktop-profile-gallery-top-728x90-btf',
    UserDesktopBrowseTop728x90Gam: 'u-desktop-browse-top-728x90-atf',
    UserDesktopBrowseBottom728x90Gam: 'u-desktop-browse-bottom-728x90-btf',
    UserMobileAdhesionGam: 'u-mobile-anchor',
    UserMobileDevPageSide300x250Gam: 'u-mobile-devpage-sidebar-300x250-btf'
};
export const ADUNIT_IDS = Object.values(ADUNIT_MAP);
// This maps adunit to dealer UUID
export const ADUNIT_FALLBACK_MAP = {
    // Anon
    DesktopDevPageSide300x250Gam: TEST_REALESTATEID,
    DesktopDevPageSide300x250AtfGam: TEST_REALESTATEID,
    DesktopDevPageSideVideoSideGam: TEST_REALESTATEID,
    DesktopDevPageStage728x90Gam: TEST_REALESTATEID,
    DesktopComments728x90Gam: TEST_REALESTATEID,
    DesktopProfileBottom728x90Gam: TEST_REALESTATEID,
    DesktopProfileTop728x90Gam: TEST_REALESTATEID,
    DesktopProfileVideoGam: TEST_REALESTATEID,
    DesktopAdhesionGam: TEST_REALESTATEID,
    DesktopBrowseTop728x90Gam: TEST_REALESTATEID,
    DesktopBrowseBottom728x90Gam: TEST_REALESTATEID,
    DesktopBrowseRight160x600Gam: TEST_REALESTATEID,
    MobileAdhesionGam: TEST_REALESTATEID,
    MobileDevPageVideoStageGam: TEST_REALESTATEID,
    MobileDevPageSide300x250Gam: TEST_REALESTATEID,
    MobileDevPageStage320x100Gam: TEST_REALESTATEID,
    MobileGridDynamic300x250Gam: TEST_REALESTATEID,
    DesktopDevPageArtStageVideo: TEST_REALESTATEID,
    // User
    UserDesktopDevPageSide300x250Gam: TEST_REALESTATEID,
    UserDesktopDevPageSide300x250AtfGam: TEST_REALESTATEID,
    UserDesktopDevPageStage728x90Gam: TEST_REALESTATEID,
    UserDesktopAdhesionGam: TEST_REALESTATEID,
    UserDesktopComments728x90Gam: TEST_REALESTATEID,
    UserMobileAdhesionGam: TEST_REALESTATEID,
    UserMobileDevPageSide300x250Gam: TEST_REALESTATEID
};
export const ADUNIT_FALLBACK_JSON_ID = '83868b70-2beb-444a-ab30-3633acc41d33';
export var AdProviders;
(function(AdProviders) {
    AdProviders["Gak"] = 'da';
    AdProviders["Primis"] = 'primis';
    AdProviders["Freestar"] = 'freestar';
    AdProviders["Hashtag"] = 'hashtag';
})(AdProviders || (AdProviders = {}));
export const ADUNIT_PROVIDER_SAFETY_KEY = {
    [AdProviders.Gak]: 'safety',
    [AdProviders.Primis]: 'safety',
    [AdProviders.Freestar]: 'safety',
    [AdProviders.Hashtag]: 'safety'
};
export function adunitMemo(last, next) {
    return last.safety === next.safety && last.safetyState === next.safetyState;
}
export const FREESTAR_PREFIX = 'deviantartcom_';
